import React, { Fragment } from 'react';
import { Row, Spinner } from 'react-bootstrap';
import { TbEditCircle } from 'react-icons/tb';
import { TiDocumentDelete } from 'react-icons/ti';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import CommonTable from 'components/CommonTable';
import { CustomButton } from 'components/CustomForm';
import useModal from 'hooks/useModal';
import { deleteIngredient, getIngredients } from 'network//apis/InformationApi';
import AddConcentrateCompundModal from './AddConcentrateCompundModal';
import CommonPrompt from "components/DeletePrompt";

const cols = [
	{ title: 'حذف', width: '10%' },
	{ title: 'ویرایش', width: '10%' },
	{ title: 'توضیحات', width: '30%' },
	{ title: 'واحد سنجش', width: '20%' },
	{ title: 'نام ترکیب', width: '30%' },
	{ title: 'ردیف', width: '5%' }
];

const Holder = styled.div`
	background-color: white;
	border-bottom-left-radius: 26px;
	border-bottom-right-radius: 26px;
	width: 100%;
	margin: 0;
	padding: 0 2rem;

	div.header-button {
		display: flex;
		justify-content: end;
		width: 100%;
		margin-bottom: 1.5rem;
	}
	div.loading {
		min-height: 30rem;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #3876e5;
	  }
`;

const ConcentrateCompoundsManagementTab = ({ currentTab = 'concentrate-compounds-management' }) => {
	const {
		isOpen,
		handleOpenModal,
		handleCloseModal,
		data: editData,
	  } = useModal();
	  const {
		isOpen: isDeleteModalOpen,
		handleOpenModal: handleOpenDeleteModal,
		handleCloseModal: handleCloseDeleteModel,
		data: deleteModalData,
	  } = useModal();
	
	  const {
		data: concentratesData,
		refetch,
		isLoading,
	  } = useQuery(["get-concentrates"], () => getIngredients(), {
		refetchOnWindowFocus: false,
		enabled: currentTab === 'concentrate-compounds-management'
	  });
	
	  const deleteConcentrateMutation = useMutation(deleteIngredient, {
		onSuccess: (res) => {
		  if (res && res.status === 204) {
			toast(`با موفقیت حذف گردید`, {
			  type: "success",
			  position: "bottom-right",
			});
			refetch();
		  }
		},
		onError: () => {
		  toast(`خطا در حذف، لطفا اتصال خود را بررسی کنید`, {
			type: "error",
			position: "bottom-right",
		  });
		},
	  });

	  return (
		<Holder>
		  {isLoading ? (
			<div className="loading">
			  <Spinner animation="border" role="status" />
			</div>
		  ) : (
			<Fragment>
			  <div className="header-button">
				<CustomButton onClick={() => handleOpenModal(null)}>
				  افزودن ترکیب
				</CustomButton>
			  </div>
			  <CommonTable cols={cols}>
				{concentratesData?.data?.map((concentrate, index) => (
				  <tr key={concentrate?.item_id}>
					<td>
					  <TiDocumentDelete
						onClick={() => {
						  handleOpenDeleteModal(concentrate);
						}}
					  />
					</td>
					<td>
					  <TbEditCircle
						onClick={() => {
						  handleOpenModal(concentrate);
						}}
					  />
					</td>
					<td>{concentrate?.description ?? "-"}</td>
					<td>{concentrate?.default_unit?.name}</td>
					<td>{concentrate?.name}</td>
					<td>{index + 1}</td>
				  </tr>
				))}
			  </CommonTable>
			</Fragment>
		  )}
		  {isOpen && (
			<AddConcentrateCompundModal
			  isOpen
			  onClose={handleCloseModal}
			  size="md"
			  data={editData}
			  onCreateSuccess={refetch}
			/>
		  )}
		  {isDeleteModalOpen && (
			<CommonPrompt
			  isOpen={isDeleteModalOpen}
			  onClose={handleCloseDeleteModel}
			  onActionTap={() => {
				handleCloseDeleteModel();
				deleteConcentrateMutation.mutate({ id: deleteModalData?.item_id });
			  }}
			/>
		  )}
		</Holder>
	  );
};

export default ConcentrateCompoundsManagementTab;
